import Link from 'next/link';
import Icon from '@components/common/assets';
import CustomImage from '@components/common/image';
import { useMatchingCompanyList } from '@repository/match';
import CompanyInterestButton from './CompanyInterestButton';
import { ActiveCompaniesSkeleton } from './MatchingActiveCompaniesSkeleton';
import Colors from '@domain/constant/colors';
import { V2Route } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const EmptyList = () => {
  return (
    <div className={cx('section')}>
      <div className={cx('sectionInner')}>
        <div className={cx('emptyArea')}>
          <strong className={cx('emptyTitle')}>공고를 기다리고 있어요.</strong>
          <p className={cx('emptyDesc')}>기업에서 채용을 시작하면 채용 공고를 확인할 수 있어요.</p>
        </div>
      </div>
    </div>
  );
};

interface CompanyCardProps {
  logoUrl: string | null;
  companyName: string;
  location: string;
  companySn: number;
  bookmarkYn: boolean;
}

const CompanyCard = ({ logoUrl, companyName, location, companySn, bookmarkYn }: CompanyCardProps) => {
  return (
    <Link className={cx('companyCardWrap')} href={V2Route.getCompanyChannelPage(companySn)}>
      <div className={cx('companyCardArea')}>
        <div className={cx('logo', { default: !logoUrl })}>
          {logoUrl ? (
            <CustomImage src={logoUrl} alt="logo" width={48} height={48} pointer className={cx('logo')} />
          ) : (
            <Icon name="logo" width={32} height={7} fill={Colors.C_COOL_GRAY_50} />
          )}
        </div>
        <h3 className={cx('companyName')}>{companyName}</h3>
        <div className={cx('location')}>
          <Icon name="pinLight" width={20} height={20} fill={Colors.C_COOL_GRAY_60} />
          {location}
        </div>
      </div>
      <CompanyInterestButton likeYn={bookmarkYn} companySn={companySn} />
    </Link>
  );
};

const MatchingActiveCompanies = () => {
  const { data: matchingCompaniesData, isFetching } = useMatchingCompanyList();
  const matchingCompanies = matchingCompaniesData?.matchingCompanies ?? [];

  return (
    <section className={cx('section')}>
      <div className={cx('sectionInner')}>
        <header className={cx('sectionTitleArea')}>
          <h2 className={cx('sectionTitle', 'main_position')}>🏢 잡다매칭에 참여 중인 기업</h2>
        </header>

        <div className={cx('descriptionWrap')}>
          <p className={cx('description')}>
            잡다매칭을 통해 적극적으로 채용하고 있는 기업이에요. 잡다매칭 참여하고 제안 받아보세요.
          </p>
        </div>

        <div className={cx('companyListWrap')}>
          {isFetching ? (
            <ActiveCompaniesSkeleton />
          ) : matchingCompanies.length === 0 ? (
            <EmptyList />
          ) : (
            matchingCompanies.map((company, index) => (
              <CompanyCard
                key={index}
                companySn={company.companySn}
                logoUrl={company.logoUrl}
                companyName={company.companyName}
                location={company.locationText}
                bookmarkYn={company.bookmarkYn}
              />
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default MatchingActiveCompanies;
